const E = {
  'QC Sample ID': 'QC Sample ID',
  Matrix: 'Matrix',
  'QC Type': 'QC Type',
  'Total QC Samples': 'Total QC Samples',
};

const F = {
  'QC Sample ID': 'ID de l’échantillon de CQ',
  Matrix: 'Matrice',
  'QC Type': 'Type de QC',
  'Total QC Samples': 'Nombre total d’échantillons de QC',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsOrderSummaryDesktopQcSampleIDs.js